import $ from 'jquery';
import { EVENTS } from '../utilities/CONSTANTS';

const getUsers = () => $.get(`/api/teams/${window.teamId}/referenceable-users`)
    .done(({ success, users, slackUsers }) => {
        window._tettraUsers = !success ? [] : users.concat(slackUsers);
        window._referencableTettraUsers = !success ? [] : users.concat(slackUsers).filter(user => !user.deactivated_at);
    }).fail((error) => {
        console.error('Error fetching users', error);
        window._tettraUsers = [];
        window._referencableTettraUsers = [];
    }).always(() => {
        window.dispatchEvent(new Event(EVENTS.USERS_LOADED));
    });

export default getUsers;
